import moment from 'moment';
import objectToFormData from 'object-to-formdata';

// Use to initialize form values
export const getInitialValues = (defaultValues, active) => {
  let initialValues = {};

  Object.keys(defaultValues).forEach((key, index) => {
    if (active[key]) {
      if (key.indexOf('_date') !== -1 || key.indexOf('_from') !== -1 || key.indexOf('_to') !== -1) {
        initialValues[key] = moment(active[key]);
      } else if (key.endsWith('_id') && active[key.slice(0, -3)]) {
        initialValues[key] = active[key.slice(0, -3)];
      } else {
        initialValues[key] = active[key];
      }
    } else {
      initialValues[key] = defaultValues[key];
    }
  });

  return initialValues;
};

export const getInitialArrayValues = (defaulArray, active) => {
  let initialArray = [];
  if (!Array.isArray(active)) return defaulArray;

  defaulArray.forEach((el, index) => {
    if (active[index]) {
      initialArray[index] = active[index];
    } else {
      initialArray[index] = el;
    }
  });
  return initialArray;
};

/* 
  Use to format form values before sending to API. 
  Returns a JSON obect.
  allowNull param should equal to TRUE in forms (create and edit) and to FALSE in every other GET method 
*/
export const getValuesAsParams = (values, allowNull) => {
  let params = {};

  Object.keys(values).forEach((key, index) => {
    if (values[key] && values[key] !== '') {
      if (key.indexOf('_date') !== -1 || key.indexOf('_from') !== -1 || key.indexOf('_to') !== -1) {
        params[key] = moment(values[key]).format('YYYY-MM-DD');
      } else if (key.endsWith('_id')) {
        params[key] = values[key].id ? values[key].id : values[key];
      } else {
        params[key] = values[key];
      }
    } else {
      if (allowNull) {
        params[key] = values[key];
      }
    }
  });

  return params;
};

/* 
  Use to format any form values that include Blobs (files) before sending to API. 
  Returns a FormData obect.
  isEdit param should equal to TRUE when editing a form.
  REMEMBER to use an axios POST method instead of a PUT to fix the multipart/form-data bug in PHP - lavarel.
*/

export const getValuesAsFormData = (values, isEdit, allowNull) => {
  const params = getValuesAsParams(values, allowNull);

  let formaDataParams = objectToFormData(params, { indices: true });
  if (isEdit) {
    formaDataParams.append('_method', 'PUT');
  }
  return formaDataParams;
};



// WEBPACK FOOTER //
// ./src/utils/form.js